<template>

	<div class="portlet box green" v-if="classLevel === 'Bercario' || classLevel === 'Infantil'">

		<div class="portlet-title">

			<div class="caption">

				<i class="fa fa-male" aria-hidden="true"></i>
				<i class="fa fa-female" aria-hidden="true"></i>

				<span v-translate>Evacuação</span>

			</div>

		</div>

		<div class="portlet-body">

			<form v-on:submit.prevent="addEvacuationItem" role="form" autocomplete="off">

				<div class="row">

					<div class="form-group col-md-6 col-xs-6" :class="{ 'has-error': errors.has('evacuation-shift') }">

						<label class="control-label" for="evacuation-shift" v-translate>Em qual turno o aluno evacuou?</label>

						<select class="form-control" id="evacuation-shift" name="evacuation-shift" @change="completionStatus(evacuation)" v-model="evacuation.shift" v-validate="'required'">
							<option value="" v-translate>Selecione</option>
							<option v-for="(value, shift) in dayShiftType" :value="shift" >{{ value }}</option>1
						</select>

					</div>

					<div class="form-group col-md-6 col-xs-6" :class="{ 'has-error': errors.has('evacuation-quantity') }">

						<label class="control-label" for="evacuation-quantity" v-translate>Quantas vezes o aluno evacuou?</label>
						<input type="number" class="form-control" id="evacuation-quantity" min="1" max="99" name="evacuation-quantity" @change="completionStatus(evacuation)" v-model="evacuation.quantity" placeholder="Exemplo: 1" v-validate="'required'">

					</div>

					<div class="form-group col-md-8 col-xs-12" :class="{ 'has-error': errors.has('evacuation-evacuation') }">

						<label class="control-label" for="evacuation-evacuation" v-translate>Qual a consistência da evacuação?</label>

						<div class="mt-radio-inline p-0">

							<label v-for="(value, key) in AgendaEvacuationType" class="mt-radio mt-radio-outline">
								<input type="radio" id="evacuation-evacuation" name="evacuation-evacuation" :value="key" @change="completionStatus(evacuation)" v-model="evacuation.evacuation" v-validate="'required'">
								{{ value }}
								<span></span>
							</label>

						</div>

					</div>

					<div class="form-group col-md-4 col-xs-12 text-right">

						<div class="btn-group" role="group">

							<div class="btn-group" role="group">

								<button type="reset" class="btn btn-link m-t-15" @click="formReset" v-translate>
									<small>Limpar</small>
								</button>

							</div>

							<div class="btn-group" role="group">

								<button type="submit" class="btn green m-t-15" :disabled="errors.items.length > 0" v-translate>
									Adicionar
								</button>

							</div>

						</div>

					</div>

				</div>

			</form>

			<div class="row" v-if="evacuations && evacuations.length > 0">

				<div class="col-md-12">

					<p class="alert alert-info p-5">
						Inclusões feitas para um mesmo turno e de mesma consistência serão unificadas.
					</p>

					<div class="table-responsive">

						<table class="table table-bordered table-hover table-striped m-b-0">
							<thead>
								<tr>
									<th v-translate>Turno que evacuou</th>
									<th v-translate>Consistência</th>
									<th v-translate>Vezes que evacuou</th>
									<th v-translate>Ações</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(evacuation, index) in evacuations">
									<td>{{ evacuation.shift | enum('DayShiftType') }}</td>
									<td>{{ evacuation.evacuation | enum('AgendaEvacuationType') }}</td>
									<td>{{ evacuation.quantity }}</td>

									<td>

										<button type="button" class="btn btn-info btn-xs" @click="editEvacuationItem(index)">
											<i class="fa fa-pencil" aria-hidden="true"></i>
										</button>

										<button type="button" class="btn btn-danger btn-xs" @click="deleteEvacuationItem(index)">
											<i class="fa fa-times" aria-hidden="true"></i>
										</button>

									</td>
								</tr>
							</tbody>
						</table>

					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<script>

	import StudentEvacueted from './';
	export default StudentEvacueted;

</script>



// WEBPACK FOOTER //
// main.vue?6ce7ffff